import React, { useContext } from 'react';
import { TableContext } from '../shared/table/context/TableContext';
import TransactionListTable from './TransactionListTable';

const TransactionSummaryContent = ({ 
  transactions, 
  activeTab,
  onTransactionClick,
  SummaryCard
}) => {
  const { filterRows, sortRows, applyFilters } = useContext(TableContext);
  const filteredTransactions = sortRows(applyFilters(filterRows(transactions)));
  
  const filteredSummary = activeTab === 'sales' ? {
    total_transactions: filteredTransactions.length,
    total_sales: filteredTransactions.reduce((sum, t) => sum + (Number(t.sale_price) || 0), 0),
    total_fees: filteredTransactions.reduce((sum, t) => sum + (Number(t.fees) || 0), 0),
    total_cost: filteredTransactions.reduce((sum, t) => sum + (Number(t.total_cost) || 0), 0),
    total_profit: filteredTransactions.reduce((sum, t) => sum + (Number(t.profit) || 0), 0),
    average_sale: filteredTransactions.length ? 
      filteredTransactions.reduce((sum, t) => sum + (Number(t.sale_price) || 0), 0) / filteredTransactions.length : 0,
    average_margin: filteredTransactions.reduce((sum, t) => sum + (Number(t.total_cost) || 0), 0) > 0 ?
      (filteredTransactions.reduce((sum, t) => sum + (Number(t.profit) || 0), 0) / 
       filteredTransactions.reduce((sum, t) => sum + (Number(t.total_cost) || 0), 0)) * 100 : 0
  } : {
    total_transactions: filteredTransactions.length,
    total_purchases: filteredTransactions.reduce((sum, t) => sum + (Number(t.purchase_price) || 0), 0),
    average_amount: filteredTransactions.length ? 
      filteredTransactions.reduce((sum, t) => sum + (Number(t.purchase_price) || 0), 0) / filteredTransactions.length : 0
  };

  return (
    <div className="flex flex-col flex-grow">
      {activeTab === 'sales' ? (
        <div className="mb-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4">
          <SummaryCard 
            title="Total Transactions" 
            value={filteredSummary.total_transactions} 
            isCurrency={false}
          />
          <SummaryCard 
            title="Total Sales" 
            value={filteredSummary.total_sales}
          />
          <SummaryCard 
            title="Total Fees" 
            value={filteredSummary.total_fees}
          />
          <SummaryCard 
            title="Total Cost" 
            value={filteredSummary.total_cost}
          />
          <SummaryCard 
            title="Total Profit" 
            value={filteredSummary.total_profit}
          />
          <SummaryCard 
            title="Average Sale" 
            value={filteredSummary.average_sale}
          />
          <SummaryCard 
            title="Average Margin" 
            value={filteredSummary.average_margin} 
            isCurrency={false}
            isPercentage={true}
          />
        </div>
      ) : (
        <div className="mb-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <SummaryCard 
            title="Total Transactions" 
            value={filteredSummary.total_transactions} 
            isCurrency={false}
          />
          <SummaryCard 
            title="Total Purchase Price" 
            value={filteredSummary.total_purchases}
          />
          <SummaryCard 
            title="Average Cost" 
            value={filteredSummary.average_amount}
          />
        </div>
      )}

      <div className="bg-white rounded-lg shadow overflow-hidden flex-grow flex flex-col">
        <TransactionListTable
          transactions={transactions}
          type={activeTab}
          onTransactionClick={onTransactionClick}
        />
      </div>
    </div>
  );
};

export default TransactionSummaryContent;
